import {createSlice, Draft, PayloadAction} from '@reduxjs/toolkit';
import {useSelector} from 'react-redux';

export enum MappingType {
    personPerson = 'person_person',
    personParcel = 'flurstueck_person',
    personLandRegister = 'grundbuch_person',
    landRegisterParcel = 'grundbuch_flurstueck',
    utilisationMeasure = 'inanpsruchnahme_massnahme',
    personCorrespondence = 'person_korrespondenz',
    parcelContract = 'flurstueck_vertrag',
    process = 'process',
    processPerson = 'process_person',
    processParcel = 'process_parcel',
}

export type Mapping = {
    id?: string,
    mapping_type: string,
    project_id: string,
    anteileigentuemer?: string,
    miteigentumsanteil?: string,
    artrechtsgemeinschaft?: string,
    person_id?: string,
    flurstueck_id?: string,
    grundbuch_id?: string,
    korrespondenz_id?: string,
    inanspruchnahme_id?: string,
    massnahme_id?: string,
    vertretung_fuer_person_id?: string,
    person_type_id?: number,
    common_data: boolean,
    remove?: boolean,
    bvnr?: number,
    gr_ha?: number,
    gr_a?: number,
    gr_m2?: number,
    lfdnr_eintragung?: string,
    lfdnr_bestandsverzeichnis?: string,
    grundlage_eintragung?: string,
    ehepartner?: string,
    erbengemeinschaft?: any[],
    korrespondenz_type_id?: string,
    datum_soll?: string,
    datum_ist?: string,
    vertrag_type_id?: string,
    flaeche_erwerb?: number,
    flaeche_dinglich?: number,
    flaeche_temp?: number,
}

// Define a type for the slice state
interface MappingData {
    mappings: Mapping[]
}

// Define the initial state using that type
const initialState: MappingData = {
    mappings: []
};

export const mappingSlice = createSlice({
    name: 'mapping',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        resetMappings: (state) => {
            //  console.log('reset mapping');
            state.mappings = [];
        },
        addMappings: (state, action: PayloadAction<any>) => {
            let temp: Mapping[] = JSON.parse(JSON.stringify(state.mappings));

            let added: boolean = false;

            for (let i = 0; i < temp.length; i++) {
                if (temp[i].id && action.payload.id && temp[i].id === action.payload.id) {
                    added = true;
                    temp[i] = JSON.parse(JSON.stringify(action.payload));
                    temp[i].remove = false;
                    break;
                }
            }

            if (!added) {
                temp.push(action.payload);
            }

            state.mappings = temp;
        },
        removeMapping: (state, action: PayloadAction<any>) => {
            let temp: Mapping[] = JSON.parse(JSON.stringify(state.mappings));

            let found = false;

            for (let i = 0; i < temp.length; i++) {
                if (temp[i].id === action.payload.id) {
                    temp[i].remove = true;
                    found = true;
                    break;
                }
            }

            if (!found) {
                temp.push(action.payload);
            }

            // console.log('mapping', temp);
            state.mappings = temp;
        },
    },
});

export const {
    resetMappings,
    addMappings,
    removeMapping
} = mappingSlice.actions;

export default mappingSlice.reducer;
